import { mapGetters, mapActions, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import { uniqBy } from 'lodash'
import Autocomplete from 'vuejs-auto-complete'
import * as BasketTypes from '@/helper/BasketTypes'
import {
  FileUpload,
  FileDownloadButton
} from '@/components'
import * as fnandoCpf from '@fnando/cpf'
import * as fnandoCnpj from '@fnando/cnpj'
import service from '@/helper/const'
import * as UserType from '@/helper/UserType'
import ClientType from '@/helper/ClientType'
import Professions from '@/helper/Professions'
import States from '@/helper/States'
import moment from 'moment'

export default {
  components: {
    Autocomplete,
    FileUpload,
    FileDownloadButton,
    draggable
  },
  data () {
    return {
      rules: {
        cpfOrCnpj: (value) => this.validatorCpfOrCnpj(value) || 'Insira um valor válido e tente novamente',
        datadc: (value) => this.validateDate(value) || 'Insira um valor válido e tente novamente'
      },
      selectedBasket: {},
      basketTypes: BasketTypes,
      _clientPlan: null,
      priceBasket: 0,
      intervalFunc: null,
      userType: UserType,
      clientType: ClientType,
      isLoading: false,
      isLoadingSelectedBasket: false,
      isLoadingGenerateDossie: false,
      statusConsult: '',
      refactorFirstLicenceDateCNH: '',
      dialogProfession: false,
      dialogState: false,
      dialogStateDispatcher: false,
      activeFields: false,
      dialogStatus: false,
      dialogStatusData: {},
      dialogStatusType: '',
      states: States,
      professions: Professions,
      keysBasketSelected: [
        'providerFlowChildrenRoot',
        'providerFlowChildrenPF',
        'providerFlowChildrenPJ'
      ],
      years: [
        { text: '2024', value: '2024' },
        { text: '2023', value: '2023' },
        { text: '2022', value: '2022' },
        { text: '2021', value: '2021' },
        { text: '2020', value: '2020' },
        { text: '2019', value: '2019' },
        { text: '2018', value: '2018' },
        { text: '2017', value: '2017' },
        { text: '2016', value: '2016' },
        { text: '2015', value: '2015' },
        { text: '2014', value: '2014' },
        { text: '2013', value: '2013' },
        { text: '2012', value: '2012' },
        { text: '2011', value: '2011' },
        { text: '2010', value: '2010' }
      ],
      months: [
        { text: 'Janeiro', value: '01' },
        { text: 'Fevereiro', value: '02' },
        { text: 'Março', value: '03' },
        { text: 'Abril', value: '04' },
        { text: 'Maio', value: '05' },
        { text: 'Junho', value: '06' },
        { text: 'Julho', value: '07' },
        { text: 'Agosto', value: '08' },
        { text: 'Setembro', value: '09' },
        { text: 'Outubro', value: '10' },
        { text: 'Novembro', value: '11' },
        { text: 'Dezembro', value: '12' }
      ]
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
    selectedBasket () {
      this.resetFieldsToNewConsult()
    }
  },
  computed: {
    ...mapGetters([
      'getterBaskets',
      'getterSelectedCallManager',
      'getterAccount',
      'getterRequestFieldsBySystemProvider',
      'getterClients',
      'getterPlanType'
    ]),
    clientPlan: {
      get () {
        return this._clientPlan
      },
      set () {
        this._clientPlan = this.getCurrentPlan()
      }
    },
    availableBaskets () {
      return this.getterBaskets ? this.getterBaskets.filter((basket) => basket.enable && (basket.idClient === this.getterAccount.idClient)) : []
    },
    availableFields () {
      return uniqBy(this.getterRequestFieldsBySystemProvider, 'name').map((item) => ({ ...item, value: '', valid: true }))
    },
    showGenerateDossieButton () {
      return this.selectedBasket.idProviderFlow !== '' && this.statusConsult !== '' && (this.getterSelectedCallManager && this.getterSelectedCallManager.result && this.getterSelectedCallManager.result.idCallManager !== '')
    },
    disableMainButton () {
      return this.showGenerateDossieButton && !this.isLoading && this.statusConsult === 'complete'
    },
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  async mounted () {
    this.checkIsCustom()
    this.getAllBaskets()
  },
  beforeDestroy () {
    this.finalizePollingCallmanager(true)

    this.SET_ALL_FIELDS_SYSTEM_PROVIDER()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions([
      'actionAddCallManager',
      'actionGetByIdCallManager',
      'actionGenerateDossie',
      'actionGetRequestFieldsBySystemProvider',
      'actionGetAllBaskets',
      'actionGetAllClients',
      'actionGetPlanTypes'
    ]),
    ...mapMutations([
      'SET_ALL_FIELDS_SYSTEM_PROVIDER'
    ]),
    getCurrentPlan () {
      const idClient = this.getterAccount.client.idClient
      const currentClient = this.getterClients.filter(client => client.idClient === idClient)
      const currentPlan = this.getterPlanType.filter(plan => plan.idPlanType === currentClient[0].idPlanType)
      if (currentPlan[0].name === 'Custom') {
        this.isCustom = true
      }
      return currentPlan[0]
    },
    formatPriceToolTip (item) {
      let result = 0
      if (this.clientPlan.name === 'Custom') {
        if (item.price) {
          result += item.price
        } else {
          item.baskets.forEach((basket) => {
            result += basket.basketPrice
          })
        }
      } else if (item.type === BasketTypes.KYC) {
        item.baskets.forEach((basket) => {
          result += basket.authorizedProvider.systemProvider.systemProviderSalesValues.filter((value) => value.idPlanType === this.clientPlan.idPlanType)[0].saleValue * this.clientPlan.kycPercentage
        })
      } else {
        item.baskets.forEach((basket) => {
          result += basket.authorizedProvider.systemProvider.systemProviderSalesValues.filter((value) => value.idPlanType === this.clientPlan.idPlanType)[0].saleValue
        })
      }
      return result
    },
    resetFieldsToNewConsult () {
      this.SET_ALL_FIELDS_SYSTEM_PROVIDER()

      this.isLoadingSelectedBasket = true
      this.statusConsult = ''
      this.isLoading = false

      this.priceBasket = this.sumValueBasket(this.selectedBasket)

      this.actionGetRequestFieldsBySystemProvider(this.selectedBasket.idProviderFlow)
        .then(() => {
          this.isLoadingSelectedBasket = false
        })
        .catch(() => {
          this.isLoadingSelectedBasket = false
        })
    },
    getNameProviders (list) {
      let providers = []

      if (list && list.length > 0) {
        providers = list.map((element) => {
          const alias = element.alias !== null ? element.alias : element.authorizedProvider.systemProvider.name
          const name = alias.replace('provider', '').replace(/-/g, ' ').toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())

          const description = (element.systemProvider && element.systemProvider.description) ? element.systemProvider.description : 'Não informado'

          return {
            description,
            name: name.trim()
          }
        })
      }

      return providers
    },
    formatTitleInput (text) {
      const cleanText = this.removeSpecialCharacters(text)
      let result = cleanText.replace('_', ' ')

      if (!text.includes('cpf') && !text.includes('cnpj')) {
        result = result.replace('_', ' ').replace(/(?:^|\s)\S/g, (a) => a.toUpperCase())
      } else {
        result = result.toUpperCase()
      }

      return result
    },
    getAllBaskets () {
      this.isLoadingSelectedBasket = true

      this.actionGetAllBaskets(this.getterAccount.idClient)
        .then(() => {
          this.isLoadingSelectedBasket = false
        })
        .catch(() => {
          this.isLoadingSelectedBasket = false
        })
    },
    handleScroll () {
      this.activeFields = window.scrollY > 0

      if (window.scrollY > 250) {
        this.activeFields = true
      } else {
        this.activeFields = false
      }
    },
    initializeConsult () {
      const onlyRequiredFields = this.availableFields.filter(item => item.required)

      const filledFields = onlyRequiredFields.filter((item) => {
        const condition = item.value && item.value !== ''

        if (item.name === 'cpf' || item.name === 'cnpj') {
          item.valid = this.validatorCpfOrCnpj(item.value)
        }

        return condition && item.valid
      })

      if (filledFields.length !== onlyRequiredFields.length) {
        this.sendToast({
          text: 'Os campos obrigatórios devem ser preenchidos corretamente!',
          type: 'warning'
        })
      } else {
        this.statusConsult = 'executing'
        this.isLoading = true

        const refactoredList = this.availableFields.map((item) => {
          const defaultObject = { field: item.name, value: item.value }

          if (defaultObject.field === 'cpf' || defaultObject.field === 'cnpj' || defaultObject.field === 'telefone') {
            defaultObject.value = this.removeSpecialCharacters(defaultObject.value)
          } else if (defaultObject.field.toLowerCase().includes('data_') || defaultObject.field.toLowerCase() === 'data') {
            defaultObject.value = (defaultObject.value.trim() !== '' && moment(defaultObject.value, 'DD/MM/YYYY').format('YYYY-MM-DD') !== 'Invalid Date') ? moment(defaultObject.value, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
          } else if (defaultObject.field === 'doc_base64' || defaultObject.field === 'doc_math_base64') {
            defaultObject.value = defaultObject.value[0] ? defaultObject.value[0].base64 : ''
          }

          return defaultObject
        })

        const guideBasket = {
          idProviderFlow: this.selectedBasket.idProviderFlow,
          Fields: refactoredList,
          Origin: 'P.A. - Consulta Individual',
          NameUser: this.getterAccount.userName,
          idUserLogged: this.getterAccount.idUser
        }

        this.actionAddCallManager(guideBasket)
          .then(() => {
            this.intervalFunc = setInterval(() => this.getByIdCallManager(), 2000)
          })
          .catch((err) => {
            if (err && err.data && err.data.code) {
              switch (err.data.code) {
                case 'INSUFFICIENT_LIMIT': {
                  this.dialogStatusData = err.data
                  this.dialogStatusType = err.data.code
                  this.dialogStatus = true
                  break
                }
                case 'INSUFFICIENT_CREDIT': {
                  this.dialogStatusData = err.data
                  this.dialogStatusType = err.data.code
                  this.dialogStatus = true
                  break
                }
                case 'DISABLED_CLIENT': {
                  this.dialogStatusData = { message: 'Não foi possível fazer a consulta pois o seu cliente está bloqueado.' }
                  this.dialogStatusType = err.data.code
                  this.dialogStatus = true
                  break
                }
                case 'DISABLED_USER': {
                  this.dialogStatusData = { message: 'Não foi possível fazer a consulta pois o seu usuário está bloqueado.' }
                  this.dialogStatusType = err.data.code
                  this.dialogStatus = true
                  break
                }
                case 'RABBIT_CALLMANAGER_ERROR': {
                  this.sendToast({
                    text: 'Não foi possível conectar com o RABBIT!',
                    type: 'warning'
                  })
                  break
                }
                default: {
                  this.sendToast({
                    text: 'Ocorreu um erro ao fazer a consulta, tente novamente mais tarde!',
                    type: 'danger'
                  })
                  break
                }
              }
            }

            this.statusConsult = ''
            this.isLoading = this.isLoadingSelectedBasket = false
          })
      }
    },
    getByIdCallManager () {
      this.actionGetByIdCallManager({ idProviderFlow: this.selectedBasket.idProviderFlow, idCallManager: this.getterSelectedCallManager.result.idCallManager })
        .then((response) => {
          if (response && response.data && Object.prototype.hasOwnProperty.call(response.data, 'allDone') && response.data.allDone) {
            this.finalizePollingCallmanager()
          }
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao verificar o status da consulta, tente novamente mais tarde!',
            type: 'warning'
          })
        })
    },
    finalizePollingCallmanager (breakPolling = false) {
      if (breakPolling && this.intervalFunc) {
        this.sendToast({
          text: 'Você não aguardou a consulta ser finalizada e saiu da página.',
          type: 'warning'
        })
      }

      clearInterval(this.intervalFunc)

      this.intervalFunc = null

      this.statusConsult = 'complete'
      this.isLoading = false
    },
    validateDate (date) {
      if (!date) {
        return true
      }
      const isDateValid = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (isDateValid !== 'Invalid date') {
        return true
      }
      return false
    },
    validatorCpfOrCnpj (value) {
      let message = false

      if (fnandoCpf.isValid(value)) {
        message = true
      } else if (fnandoCnpj.isValid(value)) {
        message = true
      }

      return message
    },
    closeModal () {
      this.dialogStatus = false

      setTimeout(() => {
        this.dialogStatusData = {}
        this.dialogStatusType = ''
      }, 250)
    },
    linkToDownload () {
      return `${service.SERVICE_DOSSIE}/${this.selectedBasket.idProviderFlow}/${this.getterSelectedCallManager.result.idCallManager}`
    },
    checkProperty (obj, property) {
      return Object.prototype.hasOwnProperty.call(obj, property) && obj[property] !== null && obj[property] !== ''
    },
    async checkIsCustom () {
      this.isLoadingSelectedBasket = true

      const allClients = await this.actionGetAllClients()
      const allPlans = await this.actionGetPlanTypes()
      const idClient = this.getterAccount.client.idClient

      const currentClient = allClients.data.filter(client => client.idClient === idClient)
      const currentPlan = allPlans.data.filter(plan => plan.idPlanType === currentClient[0].idPlanType)
      this._clientPlan = currentPlan[0]

      if (currentPlan[0].name === 'Custom') {
        this.isCustom = true
      }
      this.isLoadingSelectedBasket = false
    },
    sumValueBasket (selectedBasket) {
      let price = 0

      if (this.clientPlan.name === 'Custom') {
        if (selectedBasket.price && selectedBasket.price > 0) {
          price += selectedBasket.price
        } else if (selectedBasket.baskets && selectedBasket.baskets.length > 0) {
          selectedBasket.baskets.forEach(basket => {
            price += basket.basketPrice
          })
        }
      } else {
        selectedBasket.baskets.forEach(element => {
          const plan = element.systemProvider.systemProviderSalesValues.filter(value => value.idPlanType === this.clientPlan.idPlanType)
          if (plan.length > 0) {
            if (selectedBasket.type === 'kyc') {
              price += plan[0].saleValue * this.clientPlan.kycPercentage
            } else {
              price += plan[0].saleValue
            }
          }
        })
      }
      return (Math.round(price * 100) / 100).toString()
    },
    treatmentDataText (fieldName) {
      return fieldName === 'doc_base64' ? 'Clique para selecionar um <strong>DOCUMENTO COM FOTO</strong>, a orientação da foto pode ser <strong>RETRATO</strong> ou <strong>PAISAGEM</strong>.' : 'Clique para selecionar um <strong>ROSTO</strong>, que deseja realizar a comparação.'
    }
  }
}
